module.exports = __webpack_public_path__ + "img/smallprogram.b947a2ba.png";